import _omit from 'lodash/omit';
import _map from 'lodash/map';
import _split from 'lodash/split';
import _head from 'lodash/head';
import _isNil from 'lodash/isNil';
import APPCONFIG from '../../constants/Config';
import {
  WS_TOPIC_DEVICES,
  WS_TOPIC_DEVICE_SMS,
} from '../../constants/App';
import {
  ADD_DEVICE_EVENT,
  UPDATE_DEVICE_EVENT_STATUS,
  REGISTER_DEVICE_CMD,
  WS_RECEIVED_OPERATION,
  SEND_DEVICE_SMS_SUCCESS,
  TRIGGER_INSTALLATION_SCENARIO_SUCCESS,
  TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS,
} from '../../constants/ActionTypes';
import * as wsEvents from '../../constants/WsEvents';
// Models
import { types, infoTypes } from '../../models/deviceEvent';

const initialSettings = APPCONFIG.deviceEvent;
const deviceEvent = (state = initialSettings, action) => {
  let wsPayload;
  let wsTopic;
  let wsData;

  switch (action.type) {
    case ADD_DEVICE_EVENT:
      return {
        ...state,
        list: [...state.list, {
          type: action.eventType,
          status: action.status,
          data: { ...action.data },
        }],
      };

    case UPDATE_DEVICE_EVENT_STATUS:
      return {
        ...state,
        list: _map(state.list, (deviceEventElement) => (
          deviceEventElement.id === action.id ? {
            ...deviceEventElement,
            status: action.status,
          } : deviceEventElement
        )),
      };

    case WS_RECEIVED_OPERATION:
      wsPayload = action.payload;
      wsTopic = _head(_split(action.topic, ':'));

      // Catch EVENT_INFO operations
      if (wsPayload && wsTopic && action.operation === wsEvents.EVENT_INFO) {
        wsData = wsPayload.data;
        if (wsTopic === WS_TOPIC_DEVICES && wsData && !_isNil(wsData.timeout)) {
          /** Create a new event with structure:
            {
              type: 'deviceInfo',
              status: 'done',
              data: {
                infoType: 'timeout',
                device: {id, serial}
                value: true | false
              }
            }
          */
          return {
            ...state,
            list: [...state.list, {
              type: types.deviceInfo,
              status: 'done',
              data: {
                infoType: infoTypes.timeout,
                device: {
                  id: wsPayload.id,
                  serial: wsPayload.serial,
                },
                value: wsData.timeout,
              },
            }],
          };
        }
        if (wsTopic === WS_TOPIC_DEVICE_SMS) {
          // Find the concerned SMS and update its status
          return {
            ...state,
            list: _map(state.list, (deviceEventElement) => {
              // Check if the event is concerned by the event
              if (deviceEventElement.type === types.deviceSms) {
                // Check if this SMS is concerned by the event
                if (deviceEventElement.data.id === wsPayload.id) {
                  return {
                    ...deviceEventElement,
                    data: {
                      ...deviceEventElement.data,
                      ...wsData,
                    },
                  };
                }
                return deviceEventElement;
              }
              return deviceEventElement;
            }),
          };
        }
        return state;
      }
      return state;

    case SEND_DEVICE_SMS_SUCCESS:
      /** Create a new event with structure:
        {
          id,
          type: 'deviceSms',
          status: 'pending',
          data: {
            id,
            type: 'sync' | 'reboot' | 'reset' | 'status'
            delivery_status: 'pending' | 'delivered' | 'error',
            device: {id, serial}
          }
        }
      */
      return {
        ...state,
        list: [...state.list, {
          id: action.data.data.id,
          type: types.deviceSms,
          status: 'pending',
          data: {
            ...action.data.data,
            type: action.smsType,
            device: { ...action.device },
          },
        }],
      };

    case REGISTER_DEVICE_CMD:
      /** Create a new event with structure:
        {
          id,
          type: 'deviceCmd',
          status: 'pending',
          data: {
            asyncOperationId,
            cmd: 'sync' | 'reboot' | 'reset' | 'ping'
            device: {id, serial}
          }
        }
      */
      return {
        ...state,
        list: [...state.list, {
          id: action.asyncOperationId,
          type: types.deviceCmd,
          status: 'pending',
          data: {
            ..._omit(action, 'type'),
          },
        }],
      };

    case TRIGGER_INSTALLATION_SCENARIO_SUCCESS:
      /** Create a new event with structure:
        {
          id,
          type: 'scenarioTrigger',
          status: 'pending',
          data: {
            asyncOperationId,
            scenario: {id, name}
          }
        }
      */
      return {
        ...state,
        list: [...state.list, {
          id: action.data.data.id,
          type: types.scenarioTrigger,
          status: 'pending',
          data: {
            asyncOperationId: action.data.data.id,
            scenario: { ...action.scenario },
          },
        }],
      };

    case TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS:
      /** Create a new event with structure:
        {
          id,
          type: 'rightTrigger',
          status: 'pending',
          data: {
            asyncOperationId,
            customer: {id, name}
          }
        }
      */
      return {
        ...state,
        list: [...state.list, {
          id: action.data.data.id,
          type: types.rightTrigger,
          status: 'pending',
          data: {
            asyncOperationId: action.data.data.id,
            customer: { ...action.customer },
          },
        }],
      };

    default:
      return state;
  }
};

export default deviceEvent;



// WEBPACK FOOTER //
// ./reducers/deviceEvent/deviceEvent.js